export const getLoading = (state) => state.statistics.core.loading;
export const getError = (state) =>  state.statistics.core.error;
export const getData = (state) =>  state.statistics.core.data;
